import loadable from '@loadable/component';

export const LoadableImageGalleryDrawer = loadable(
  () => import(/* webpackChunkName: "ImageGalleryDrawer" */ './index'),
  {
    resolveComponent: (mod) => mod.ImageGalleryDrawer,
    fallback: null as unknown as JSX.Element,
  }
);
